import React, { FC } from 'react';
import dayjs from 'dayjs';
import { Table as ShellTable } from '@sede-enterprise/shell-ds-react-framework';
import {
  THead,
  TBody,
  TH as Th,
  TD as Td,
  TR as Tr,
} from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Table/components/TableElements/TableElements';
import Button from 'src/UI/Button';
import { Modal } from '../NominationGroups/style';
import { COMMON_MESSAGES } from 'src/constants/Common';
import { IMarketBalance } from 'src/types/EUMarkets.type';

interface IViewBalancesProps {
  open: boolean;
  onClose: () => void;
  balances: IMarketBalance[];
  marketName: string;
}

const ViewBalances: FC<IViewBalancesProps> = ({ open, onClose, balances, marketName }) => {
  const renderDate = (dateValue?: string | null) =>
    dateValue ? dayjs(dateValue).format(COMMON_MESSAGES.DATE_DD_MMM_YYYY) : 'No Expiry';

  return (
    <Modal
      open={open}
      onClose={onClose}
      maskClosable={false}
      isDraggable
      width={1000}
      footer={
        <div className='button-style'>
          <Button variant='outlined' onClick={onClose} data-testid='close'>
            Close
          </Button>
        </div>
      }
      title={`Balances for market: ${marketName}`}
    >
      <ShellTable className='shell-table' data-testid='balances-table' size='small'>
        <THead>
          <Tr>
            <Th>Balance</Th>
            <Th>Internal Entity</Th>
            <Th>Valid From</Th>
            <Th>Valid To</Th>
          </Tr>
        </THead>
        <TBody>
          {balances.map((balance) => (
            <Tr key={balance.id}>
              <Td>{balance.balanceName}</Td>
              <Td>{balance.organizationName || '-'}</Td>
              <Td>{renderDate(balance.validFrom)}</Td>
              <Td>{renderDate(balance.validTo)}</Td>
            </Tr>
          ))}
          {!balances.length && (
            <Tr>
              <Td colSpan={4} className='no-data-cell'>
                <div className='title_wrapper'>
                  <h3>No data found</h3>
                </div>
              </Td>
            </Tr>
          )}
        </TBody>
      </ShellTable>
    </Modal>
  );
};

export default ViewBalances;
